export const PR_MAX_RELEASES_PEG_PAGE = 8;
export const PR_ROOT_URL = '/pr';
